var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"app-card"},[_c('fude-table',{staticClass:"moving-regions",attrs:{"settings":_vm.settings},scopedSlots:_vm._u([{key:"region",fn:function({ item }){return _c('span',{},[_vm._v("\n            "+_vm._s(item.region_name)+"\n       ")])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }